'use strict';
import React from 'react';
import classNames from 'classnames';
/**
 * Defines spacing for a group of standard buttons: arrange form buttons on a
 * form or within a page header.
 *
 * Usage:
 *
 * ```Javascript
 * <ButtonGroup>
 *   <Button>Button1</Button>
 *   <Button secondary>Button2</Button>
 * </ButtonGroup>
 * ```
 *
 * @extends {React.Compponent}
 */
class ButtonGroup extends React.Component {

  /**
   * @return {String} Component CSS classname.
   */
  getClassName () {
    return classNames({
      'Button-Group': true,
      [`${this.props.className}`]: !!this.props.className

    });
  }

  /**
   * @return {JSX} JSX component markup.
   */
  render () {
    return (
      <div className={this.getClassName()}>
        {this.props.children}
      </div>
    );
  }
}

ButtonGroup.defaultProps = {
};

export default ButtonGroup;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/inputs/buttonGroup.jsx